<template>
  <button class="tab-underline" @click="(e) => toggleActiveTab(e, tabText)">
    <div class="tab-underline__header">
      <component :is="tabIcon"></component>
      {{ tabText }}
      ({{ amount }})
    </div>
  </button>
</template>
<script setup lang="ts">
import { toRefs } from 'vue'

const props = defineProps({
  tabText: {
    type: String,
    required: true
  },
  tabIcon: {
    type: Object,
    required: false,
    default: () => undefined
  },
  amount: {
    type: [Number, String],
    default: 0
  }
})
const { tabText, amount } = toRefs(props)
const emits = defineEmits(['toggleActiveTab'])

function toggleActiveTab(e, tabTitle: string) {
  emits('toggleActiveTab', tabTitle)
  if (e) e.currentTarget.toggleAttribute('active')
  e.currentTarget.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'end' })
}
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/font-mixins.scss';

.tab-underline {
  background-color: transparent;
  border: none;
  border-bottom: variables.$button-text-icon-border;
  cursor: pointer;
  padding: 0;
  position: relative;
  width: fit-content;
  height: variables.$dropdown-height-medium;
  @include font-mixins.desktop-bold-h5;
  &__header {
    display: flex;
    flex-wrap: nowrap;
    width: max-content;
  }
  &:focus {
    outline: none;
  }
  &[active],
  &:hover {
    color: variables.$color-primary;
    &::after {
      bottom: -1px;
      border-bottom: variables.$button-outline-border-hover;
      content: '';
      display: block;
      position: absolute;
      width: 100%;
    }
  }
  &:focus-visible {
    .tab-underline__header {
      border-radius: variables.$border-width-small;
      outline: variables.$button-text-icon-outline;
      outline-width: variables.$border-width-small;
    }
  }

  @media screen and (max-width: 1024px) {
    @include font-mixins.desktop-bold-paragraph;
    &__header {
      svg {
        margin-right: 8px;
      }
    }
  }
}
</style>
